// Floating viewer panels and action buttons must use these shared token-backed styles.
// Do not invent one-off panel glass/background/border/shadow or CTA values in components.
export const viewerPanelSurfaceSx = {
  background:
    "var(--surface-gradient-dark, linear-gradient(160deg, rgba(10, 16, 24, 0.88) 0%, rgba(12, 18, 28, 0.8) 100%))",
  borderRadius: "var(--radius-lg, 14px)",
  boxShadow: "var(--surface-shadow, 0 14px 34px rgba(0, 0, 0, 0.34))",
  backdropFilter:
    "blur(var(--surface-blur, 10px)) saturate(var(--surface-saturate, 120%))",
  WebkitBackdropFilter:
    "blur(var(--surface-blur, 10px)) saturate(var(--surface-saturate, 120%))",
};

export const getViewerPanelPaddingSx = (isPhone = false) => ({
  px: isPhone ? 1.5 : 2,
  py: isPhone ? 1 : 1.15,
});

const viewerActionButtonHoverSx = {
  background:
    "var(--recording-cta-gradient-hover, linear-gradient(135deg, rgba(161, 248, 241, 1) 0%, rgba(109, 234, 224, 1) 100%))",
  borderColor: "rgba(210, 255, 249, 0.42)",
  boxShadow:
    "0 0 20px rgba(89, 218, 230, 0.24), var(--recording-cta-shadow, 0 10px 24px rgba(77, 196, 187, 0.35))",
  color: "var(--recording-cta-text, #083033)",
  transform: "translateY(-1px)",
};

export const viewerActionButtonSx = {
  minHeight: 44,
  px: 1.9,
  py: 0,
  borderRadius: "12px",
  border: "1px solid rgba(210, 255, 249, 0.28)",
  background:
    "var(--recording-cta-gradient, linear-gradient(135deg, rgba(133, 245, 236, 1) 0%, rgba(90, 222, 212, 1) 100%))",
  boxShadow:
    "var(--recording-cta-shadow, 0 10px 24px rgba(77, 196, 187, 0.35))",
  backdropFilter:
    "blur(var(--surface-blur, 10px)) saturate(var(--surface-saturate, 120%))",
  WebkitBackdropFilter:
    "blur(var(--surface-blur, 10px)) saturate(var(--surface-saturate, 120%))",
  color: "var(--recording-cta-text, #083033)",
  textDecoration: "none",
  appearance: "none",
  fontFamily: "inherit",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  gap: 0.65,
  whiteSpace: "nowrap",
  cursor: "pointer",
  pointerEvents: "auto",
  transition:
    "transform 160ms ease, box-shadow 160ms ease, background 160ms ease, border-color 160ms ease, color 160ms ease",
  "&:hover": viewerActionButtonHoverSx,
  "&:focus-visible": {
    ...viewerActionButtonHoverSx,
    outline: "2px solid rgba(161, 241, 224, 0.82)",
    outlineOffset: 3,
  },
  "&:active": {
    boxShadow:
      "0 2px 5px rgba(0, 48, 58, 0.32), inset 0 1px 2px rgba(0, 0, 0, 0.22)",
    transform: "translateY(1px)",
  },
  "&:disabled, &[aria-disabled='true']": {
    background: "var(--recording-cta-disabled, rgba(133, 245, 236, 0.35))",
    boxShadow: "none",
    color: "var(--recording-cta-text-disabled, rgba(6, 25, 27, 0.5))",
    cursor: "not-allowed",
    transform: "none",
  },
};

export const viewerActionButtonLabelSx = {
  color: "inherit",
  fontWeight: 700,
  letterSpacing: "0.01em",
  lineHeight: 1.1,
};
